import type { BlockConfigExport } from '@tmh-website/components/blocks.types';
import { FormVariant, StaticFormVariant } from '@tmh-website/services/form.service';
import { LocalePrefix } from '@tmh-website/shared/const';

import type { DynamicFormVariant, FormAlignment } from './Form.types';

export const formConfig: BlockConfigExport = {
  // If the block should decrease padding to the previous block if they have the some background color
  consecutiveBlockPadding: true,
  // Which fields should be populated by Strapi
  populateOptions: [],
};

const ALL_LOCALES: LocalePrefix[] = Object.values(LocalePrefix);

export const DEFAULT_FORM_ALIGNMENT: FormAlignment = 'center';

export const FORM_VARIANT_TO_SUPPORTED_LOCALES_MAP: Record<DynamicFormVariant | StaticFormVariant, LocalePrefix[]> = {
  [FormVariant.Hubspot]: ALL_LOCALES,
  [FormVariant.Mailchimp]: ALL_LOCALES,
  [StaticFormVariant.BusinessUnitChargingWeb2Case]: [LocalePrefix.De, LocalePrefix.DeCH],
  [StaticFormVariant.BusinessUnitSolutionsWeb2Case]: [
    LocalePrefix.De,
    LocalePrefix.DeCH,
    LocalePrefix.En,
    LocalePrefix.EnUS,
  ],
  [StaticFormVariant.Complaint]: ALL_LOCALES,
  [StaticFormVariant.ContactCH_DE]: [LocalePrefix.De, LocalePrefix.DeCH],
  [StaticFormVariant.ContactEN]: [LocalePrefix.En, LocalePrefix.EnUS],
  [StaticFormVariant.ETContact]: ALL_LOCALES,
  [StaticFormVariant.ETWeb2CaseContact]: ALL_LOCALES,
  [StaticFormVariant.ETWeb2CaseSupport]: ALL_LOCALES,
  [StaticFormVariant.Payment]: ALL_LOCALES,
  [StaticFormVariant.ProductSupport]: ALL_LOCALES,
  [StaticFormVariant.ProductSupportUSA_EN]: [LocalePrefix.En, LocalePrefix.EnUS],
  [StaticFormVariant.Shipping]: ALL_LOCALES,
  [StaticFormVariant.SupportForEvDriversWeb2Case]: [LocalePrefix.De, LocalePrefix.DeCH],
  [StaticFormVariant.Web2Case]: ALL_LOCALES,
};
